import { Component, Input, OnInit } from '@angular/core';
import { texts } from '../activity-item.texts';

@Component({
  standalone: false,
  selector: 'sc-activity-item-project-jobsite-commented',
  templateUrl: './activity-item-project-jobsite-commented.component.html',
  styleUrls: ['./activity-item-project-jobsite-commented.component.scss']
})
export class ActivityItemProjectJobsiteCommentedComponent implements OnInit {
  
  @Input()
  activity : any;

  @Input()
  condensed = false;

  @Input()
  showProjectName = false;

  @Input()
  language: 'de' | 'en' = 'de';

  texts = texts;
  
  constructor() { }

  ngOnInit(): void {
  }

}
